"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initMobileConnector = exports.initMobileConnectorWithoutSession = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const mobileConnector_1 = require("./mobileConnector");
const mobileConnectorV2_1 = require("./mobileConnectorV2");
const mock_1 = require("./mock");
const SCHEME = 'gswebview';
const initMobileConnectorWithoutSession = async () => {
    let deviceConnector;
    if ((0, web_ui_framework_1.isAndroidWebView)()) {
        deviceConnector = new web_ui_framework_1.AndroidDeviceConnector();
    }
    else if ((0, web_ui_framework_1.isIosWebView)()) {
        deviceConnector = (0, web_ui_framework_1.isProtocol2)() ? new web_ui_framework_1.IOSDeviceConnectorV2({ scheme: SCHEME }) : new web_ui_framework_1.IOSDeviceConnector();
    }
    else {
        throw new Error('Mobile communicator initialization error. Need to run in Android or iOS webview');
    }
    if ((0, web_ui_framework_1.isProtocol2)()) {
        return new mobileConnectorV2_1.MobileConnectorV2(deviceConnector, new web_ui_framework_1.MobileHandlerV2(deviceConnector));
    }
    return new mobileConnector_1.MobileConnector(deviceConnector, new web_ui_framework_1.MobileHandler(deviceConnector));
};
exports.initMobileConnectorWithoutSession = initMobileConnectorWithoutSession;
const initMobileConnector = async (session, mobileConnectorConfig) => {
    let deviceConnector;
    if ((0, web_ui_framework_1.isAndroidWebView)()) {
        deviceConnector = new web_ui_framework_1.AndroidDeviceConnector();
    }
    else if ((0, web_ui_framework_1.isIosWebView)()) {
        deviceConnector = (0, web_ui_framework_1.isProtocol2)() ? new web_ui_framework_1.IOSDeviceConnectorV2({ scheme: SCHEME }) : new web_ui_framework_1.IOSDeviceConnector();
    }
    else if ((0, mock_1.isMobileCommunicatorMockMode)()) {
        deviceConnector = (0, mock_1.getDeviceConnectorMock)(session, mobileConnectorConfig);
    }
    else {
        throw new Error('Mobile communicator initialization error. Need to run in Android or iOS webview or in mock mode');
    }
    if ((0, web_ui_framework_1.isProtocol2)()) {
        return new mobileConnectorV2_1.MobileConnectorV2(deviceConnector, new web_ui_framework_1.MobileHandlerV2(deviceConnector));
    }
    return new mobileConnector_1.MobileConnector(deviceConnector, new web_ui_framework_1.MobileHandler(deviceConnector));
};
exports.initMobileConnector = initMobileConnector;
//# sourceMappingURL=initialization.js.map